import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberTerminationStatusForm from '../../../components/forms/MemberTerminationStatusForm';
import { useMemberTerminationStatusById, useUpdateMemberTerminationStatus } from '../../../hooks/useMemberTerminationStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberTerminationStatusDTO } from '../../../services/apiClient';

const MemberTerminationStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberTerminationStatusById(id!);
  const updateMutation = useUpdateMemberTerminationStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Termination Statuses', href: '/admin/memberterminationstatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/memberterminationstatuses');
    } catch (error) {
      console.error('Error updating MemberTerminationStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberterminationstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberTerminationStatus.Edit'
    >
        {entityData ? (
          <MemberTerminationStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberterminationstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberTerminationStatusEdit;